document.addEventListener("DOMContentLoaded", () => {
  const callout = document.getElementById("bevVideoCallout");
  const close = document.querySelector(".bev-video-callout-close");

  if (!callout) return;

  // Si la popup a déjà été fermée pendant cette visite
  if (sessionStorage.getItem("bevVideoCalloutClosed")) return;

  // Affichage après 8 secondes
  setTimeout(() => {
    callout.classList.add("is-visible");
  }, 8000);

  // Fermeture
  if (close) {
    close.addEventListener("click", () => {
      callout.classList.remove("is-visible");
      sessionStorage.setItem("bevVideoCalloutClosed", "true");
    });
  }
});